import { Employee } from "src/redux/types/_employee.type";
import { formatDate } from "src/utils";

const calcNetPay = (basicPay: number, allowances: number) => {
  const netPay = basicPay + allowances;
  return `₹${netPay.toLocaleString()}`;
};

interface SalaryTableProps {
  employees: Employee[];
}

const SalaryTable: React.FC<SalaryTableProps> = ({employees}) => {

  return (
    <div>
      <table className="min-w-full text-sm text-left border border-gray-200">
        <thead className="bg-gray-100 text-gray-700 uppercase">
          <tr>
            <th className="px-4 py-2 text-center">ID</th>
            <th className="px-4 py-2 text-center">Name & Email</th>
            <th className="px-4 py-2 text-center">Dept</th>
            <th className="px-4 py-2 text-center">Basic Pay</th>
            <th className="px-4 py-2 text-center">Allowance</th>
            <th className="px-4 py-2 text-center">Net Pay</th>
            <th className="px-4 py-2 text-center">Date Of Joining</th>
            <th className="px-4 py-2 text-center">Status</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((record) => (
            <tr
              key={record.id}
              className="border-t border-gray-200 hover:bg-gray-50"
            >
              <td className="px-4 py-2 text-center">{record.id}</td>
              <td className="px-4 py-2 text-center">
                <p className="font-semibold uppercase">
                  {record.full_name}
                </p>
                <p className="text-md text-gray-700">{record.email}</p>
              </td>
              <td className="px-4 py-2 text-center uppercase">
                {record.department}
              </td>
              <td className="px-4 py-2 text-center">
                {formatDate(record.date_of_joining)}
              </td>
              <td className="px-4 py-2 text-center">
                {" "}
                <span className="bg-amber-200 px-2 rounded-lg">Pending</span>
              </td>
              <td className="px-4 py-2 flex justify-center">
                <button className="btn btn-sm btn-success">Pay</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalaryTable;
